

import React from 'react'
 import Reception  from "../images/Reception.jpeg";
 import office from "../images/office.jpeg";
 import lodgegreenhouse_office from "../images/about.jpeg";
function AboutSlide() {
  return (
    <div>
        <div id="carouselExampleDark" class="carousel carousel-dark slide" data-bs-ride="carousel">
  <div class="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="2" aria-label="Slide 3"></button>
  </div>
  <div class="carousel-inner">
    <div class="carousel-item active" data-bs-interval="10000">
     <img src={Reception} className="d-block w-100" alt="Reception"/>
      
    </div>
    <div class="carousel-item" data-bs-interval="2000">
    <img src={office} className="d-block w-100" alt="Lodge Green House"/>
      
    </div>
    <div class="carousel-item">
     <img src={lodgegreenhouse_office} className="d-block w-100" alt="lodgegreenhouse_office"/>
      
    </div>
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleDark" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleDark" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>
    </div>
  )
}

export default AboutSlide